export default defineNuxtPlugin((nuxtApp) => {
	// process.env.NODE_TLS_REJECT_UNAUTHORIZED = 0;

	const runtimeConfig = useRuntimeConfig();
	const backendUrl = runtimeConfig.public.backendUrl;
	const baseUrl = backendUrl + "/api/v1/"

	const api = $fetch.create({
		baseURL: baseUrl
	})

	return {
		provide: {
			api
		}
	}
})
